import { IOnboardingRepository } from '../../domain/repositories/IOnboardingRepository';
import { OnboardingProgressDTO } from '../dto/OnboardingProgressDTO';
import { OnboardingMapper } from '../mappers/OnboardingMapper';

/**
 * GetOnboardingProgressUseCase
 * Retrieves current onboarding progress for a user-role combination
 *
 * Business Logic:
 * - Calls repository.getProgress() which creates record if none exists
 * - Maps entity to DTO
 * - Returns DTO with computed fields (progressPercentage, isFirstStep, etc.)
 */
export class GetOnboardingProgressUseCase {
  constructor(private readonly repository: IOnboardingRepository) {}

  /**
   * Execute the use case
   *
   * @param userId - UUID of the user
   * @param role - User role ('director' | 'teacher' | 'student')
   * @returns Promise<OnboardingProgressDTO> - Current progress state
   */
  async execute(userId: string, role: string): Promise<OnboardingProgressDTO> {
    const progress = await this.repository.getProgress(userId, role);
    return OnboardingMapper.progressToDTO(progress);
  }
}
